import { activityLogSlice } from "./reducer";
export const {
  deleteMonitoring,
  dismissedAfterFirstMediaCaptureDialog,
  eventEnded,
  eventMediaUploaded,
  monitoringEnded,
  monitoringStarted,
  monitoringUploaded,
  openedDescription,
  updateMotionCapture,
  updateNoiseCapture,
  updateStorageId
} = activityLogSlice.actions;
